import { FileDown, Ruler } from "lucide-react";

export default function BoxSizeSpecs({ product, sizeKey, onSelectSize }) {
  const size = product.sizes.find((s) => s.key === sizeKey);
  if (!size) return null;
  const specs = product.box_specs || {};
  const guidelines = product.artwork_guidelines_url || "/templates/display-mailer/Artwork_Guidelines.pdf";
  const sides = Object.keys(size.templates || {});
  const rows = [
    ["Dimensions, inside", size.inside],
    ["Dimensions, outside*", size.outside],
    ["Weight (blank)", `${size.weight_oz} oz`],
    ["USPS cubic tier", size.usps_tier ? `${size.cubic_ft} ft³ · Tier ${size.usps_tier}` : "Not cubic-eligible (ships by weight)"],
    ["Board", specs.board || "White E-flute corrugated · white inside & out"],
    ["Closure", specs.closure || "Front roll tuck · no glue or tape"],
  ];
  return (
    <section className="bg-white border border-slate-200" data-testid="box-size-specs">
      <div className="px-5 py-4 border-b border-slate-200 flex items-center gap-2">
        <Ruler className="w-4 h-4 text-kolt-orange" />
        <h3 className="font-heading text-lg font-bold text-kolt-slate">Size specs & templates</h3>
      </div>
      <div className="px-5 py-3 flex gap-2 overflow-x-auto border-b border-slate-200" data-testid="box-size-chips">
        {product.sizes.map((s) => (
          <button key={s.key} type="button" onClick={() => onSelectSize(s.key)} data-testid={`size-chip-${s.key}`}
            className={`shrink-0 px-3 py-1.5 text-xs font-mono border transition-colors ${s.key === sizeKey ? "bg-kolt-slate text-white border-kolt-slate" : "border-slate-300 text-slate-600 hover:border-kolt-slate"}`}>
            {s.name.replace(/"/g, "″")}
          </button>
        ))}
      </div>
      <div className="grid md:grid-cols-2">
        <dl className="px-5 py-4 divide-y divide-slate-100">
          <div className="pb-2">
            <div className="font-heading text-xl font-bold text-kolt-slate">{size.name}</div>
            {size.note && <span className="badge-accent mt-1">{size.note}</span>}
          </div>
          {rows.map(([k, v]) => (
            <div key={k} className="flex justify-between gap-4 py-2 text-sm">
              <dt className="text-slate-500">{k}</dt>
              <dd className="font-semibold text-kolt-slate text-right">{v}</dd>
            </div>
          ))}
          <p className="pt-2 text-[11px] text-slate-400">* Outside dimensions are approximate and vary slightly with assembly.</p>
        </dl>
        <div className="px-5 py-4 bg-slate-50 border-t md:border-t-0 md:border-l border-slate-200">
          <div className="overline mb-3">Dieline templates · {size.name}</div>
          <div className="space-y-2">
            {sides.map((side) => (
              <a key={side} href={size.templates[side]} download data-testid={`template-download-${side}`}
                className="flex items-center justify-between gap-3 bg-white border border-slate-300 hover:border-kolt-orange px-4 py-3 text-sm font-semibold text-kolt-slate transition-colors">
                {side === "inside" ? "Inside dieline (PDF)" : sides.length > 1 ? "Outside dieline (PDF)" : "Dieline template (PDF)"} <FileDown className="w-4 h-4 text-kolt-orange" />
              </a>
            ))}
            <a href={guidelines} download data-testid="template-download-guidelines"
              className="flex items-center justify-between gap-3 border border-dashed border-slate-300 hover:border-kolt-orange px-4 py-3 text-sm text-slate-600 transition-colors">
              Artwork guidelines (PDF) <FileDown className="w-4 h-4" />
            </a>
          </div>
          <p className="text-xs text-slate-500 mt-3">Place art on the template, keep text 0.25″ from folds and cuts, hide the dieline layer and export a print-ready PDF.</p>
        </div>
      </div>
    </section>
  );
}
